// src/hooks/useLocalStorage.js

import { useState, useCallback, useEffect } from 'react';

export const useLocalStorage = (key, initialValue) => {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            if (typeof window === 'undefined' || !window.localStorage) {
                return initialValue;
            }
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error(`Error reading localStorage key "${key}":`, error);
            return initialValue;
        }
    });

    const setValue = useCallback((value) => {
        try {
            setStoredValue(prevValue => {
                const valueToStore = value instanceof Function ? value(prevValue) : value;
                
                // Verificar que el valor no sea undefined
                if (valueToStore === undefined) {
                    console.warn(`Attempting to set undefined value for localStorage key "${key}"`);
                    return prevValue;
                }
                
                if (typeof window !== 'undefined' && window.localStorage) {
                    window.localStorage.setItem(key, JSON.stringify(valueToStore));
                }
                
                return valueToStore;
            });
        } catch (error) {
            console.error(`Error setting localStorage key "${key}":`, error);
        }
    }, [key]);

    // Efecto para verificar la integridad del valor
    useEffect(() => {
        if (storedValue === undefined && initialValue !== undefined) {
            console.warn(`localStorage hook for key "${key}" has undefined value, resetting to initial value`);
            setStoredValue(initialValue);
        }
    }, [storedValue, initialValue, key]);

    return [storedValue, setValue];
};